module.exports = __webpack_public_path__ + "img/terminal.9c64ca5f.png";